import { render, staticRenderFns } from "./FormNewCamSms.vue?vue&type=template&id=a6996c2a&scoped=true&"
import script from "./FormNewCamSms.vue?vue&type=script&lang=js&"
export * from "./FormNewCamSms.vue?vue&type=script&lang=js&"
import style0 from "./FormNewCamSms.vue?vue&type=style&index=0&id=a6996c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6996c2a",
  null
  
)

export default component.exports